    <span class="fs-20 fw-500">{{ 'INSTANCE_DETAILS.TOTAL_TIME_TAKEN' | transloco }}</span>
    <div *ngIf="isResponseOk && timetakenChartLoaded && runHours && shutDownHours" class="flex items-center">
        <div echarts [options]="timeTakenPie" class="metrics-chart p-10 ml-[-34px]"></div>
        <div class="flex flex-wrap gap-y-3 gap-x-[120px]">
            <div class="flex flex-col" *ngFor="let item of timeTakenInfo">
                <div class="flex gap-2">
                    <span class="time-taken-color-box" [ngStyle]="{ 'background-color': item.color }"></span>
                    <span class="time-label fs-16 fw-500">{{ item.label }}</span>
                </div>
                <div class="time-value fs-18 fw-600 pl-16">{{ item.value }}</div>
            </div>
        </div>
    </div>
    <div *ngIf="!isResponseOk && !timetakenChartLoaded && !isErrorResponse" class="flex items-center justify-center metrics-spinner">
        <mat-spinner diameter="20" color="primary" mode="indeterminate"></mat-spinner>
    </div>
    <div *ngIf="((isResponseOk && !isErrorResponse) || (!isResponseOk && isErrorResponse)) && (!runHours && !shutDownHours)" class="no-data flex items-center justify-center pt-8 pb-8 fw-500 fs-16 mt-8 metrics-spinner mb-0 mat-subtitle-1">
        <mat-icon svgIcon="error" class="icon-md-1 metrics-unavailable"></mat-icon>
        <span class="metrics-unavailable ml-4">{{ 'INSTANCE_DETAILS.USAGE_NOT_AVAILABLE' | transloco }}</span>
    </div>
